// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import './fonts'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

const opts = {
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                primary: '#000000',
                secondary: '#ffffff',
                accent: '#737373',
                error: 'ff0000',
                //info: '#2196F3',
                //success: '#4CAF50',
                //warning: '#FFC107',
                background: '#ffffff',
                back: '#f9f9f9',
                text: '#757575',
                hightext: '#aaaaaa',
                title: '#000000',
                border: '#ececec',
                highborder: '#dddddd',
                highlight: '#ffffff',
            },
            dark: {
                primary: '#ffffff',
                secondary: '#000000',
                accent: '#9298af',
                error: 'ff0000',

                background: '#262830',
                back: '#1e2028',
                text: '#9298af',
                hightext: '#4d5269',
                title: '#ffffff',
                border: '#2d303e',
                highborder: '#4d5269',
                highlight: '#40434f',
            },
        },
        options: {
            customProperties: true,
        },
        dark: true
    },
};

export default new Vuetify(opts);